import Vue from 'vue'
import RouterView from 'vue-router'
import {
	BasicLayout
} from '@/components/layouts'
Vue.use(RouterView)

const originalPush = RouterView.prototype.push
//修改原型对象中的push方法
RouterView.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [{
	path: '/',
	name: 'home',
	component: BasicLayout,
	redirect: '/index',
	children: [
	  {
	    path: 'index',
	    name: 'index',
	    component: () => import('@/views/Index/index')
	  },{
	    path: 'coreTechnology',
	    name: 'coreTechnologyList',
	    component: () => import('@/views/CoreTechnologyList/index')
	  },{
	    path: 'product',
	    name: 'productList',
	    component: () => import('@/views/ProductList/index')
	  },{
	    path: 'project',
	    name: 'projectList',
	    component: () => import('@/views/ProjectList/index')
	  },{
	    path: 'aboutMe',
	    name: 'aboutMe',
	    component: () => import('@/views/AboutMe/index')
	  },{
	    path: 'search',
	    name: 'searchList',
	    component: () => import('@/views/SearchPage/index')
	  },{
	    path: 'contactUs',
	    name: 'contactUs',
	    component: () => import('@/views/ContactUs/index')
	  },{
	    path: 'sample',
	    name: 'sampleExp',
	    component: () => import('@/views/SampleExpForm/index')
	  },{
	    path: 'detail',
	    name: 'contentDetail',
	    component: () => import('@/views/ContentDetail/index')
	  }
	]
}]

let router = new RouterView({
	mode: 'hash',
	routes
})

export default router;